export default {
  placeholder: 'Buscar',
  cancel: 'Cancelar',
};
